import { useSelector } from "react-redux";
import styled from "styled-components";
import {
  BASIC_DARK_GRAY,
  BASIC_GRAY,
  BASIC_WHITE,
  BASIC_YELLOW,
} from "../../../constants/colors";
import { authSelectors } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { Button } from "../../atoms/Button";
import { useUserGuide } from "./hook";

export const UserGuide: React.FC = () => {
  const { navigateToTopPage } = useNavigation();
  const { handleClick } = useUserGuide();
  const isLoggedIn = useSelector(authSelectors.isLoggedIn);

  return (
    <Container>
      <TitleWrapper>ご利用ガイド</TitleWrapper>

      <CaptionContainer>
        <Caption>
          ジョイフルのテイクアウト「Joyfull
          ネット注文」は、カンタンにご利用いただけます。PC・スマホでご利用店舗を検索しご注文。あとはご指定のジョイフルの店舗で商品を受け取りください。
        </Caption>
        <Guide_img01>
          <img
            src={require("../../../assets/user_guide/img01.png")}
            srcSet={require("../../../assets/user_guide/img01@2x.png")}
            width="305"
            height="168"
            alt="Guide Image1"
          />
        </Guide_img01>
      </CaptionContainer>
      <TitleWrapper2>ご利用方法</TitleWrapper2>

      <StepContainer>
        <StepTitle>
          <StepNum>1</StepNum>まずは会員登録
        </StepTitle>
        <StepCaption>
          ご利用には会員登録（無料）が必要です。お手数ですが「新規会員登録はこちら」ボタンより会員登録を行ってください。
        </StepCaption>
        <List>
          <ul>
            <li>会員IDは、ご登録メールアドレスになります。</li>
            <li>フィーチャーフォンではご利用になれません。</li>
            <li>
              スマートフォンなどで、各携帯会社のメールをご利用の場合は、指定受信で「@joyfull-weborder.jp」を受信設定してください。
            </li>
          </ul>
        </List>

        <SubStepContainer>
          <SubTitle>会員登録までのステップ</SubTitle>
          <StepList>
            <StepItem>
              <span className="pre_num">step 1</span>
              <StepText>利用規約、個人情報保護方針に同意</StepText>
            </StepItem>
            <StepItem>
              <span className="pre_num">step 2</span>
              <StepText>メールアドレスを送付</StepText>
            </StepItem>
            <StepItem>
              <span className="pre_num">step 3</span>
              <StepText>会員情報入力</StepText>
            </StepItem>
            <StepItem>
              <span className="pre_num">step 4</span>
              <StepText>完了</StepText>
            </StepItem>
          </StepList>
        </SubStepContainer>
        <ButtonWrapper>
          <Button
            text={"新規会員登録はこちら"}
            btnStyle={"primary"}
            onClick={handleClick}
            disabled={isLoggedIn}
            rounded="md"
          ></Button>
        </ButtonWrapper>
      </StepContainer>

      <StepContainer>
        <StepTitle>
          <StepNum>2</StepNum>ご利用店舗の選択
        </StepTitle>
        <StepCaption>
          PC・スマートフォンで、ご利用になるジョイフルの店舗を検索してください。
          <br />
          検索したら、お受け取り日を設定し「最短でお受け取り」「時間を指定する」からお受け取り時間を指定してください。
        </StepCaption>
        <List>
          <ul>
            <li>
              「最短でお受け取り」はご注文完了より約20分後に受け取るサービスです。
            </li>
            <li>「時間を指定してお受け取り」は、6日後までご指定が可能です。</li>
            <li>
              スマートフォンで「現在地から選択」場合は、ご利用ブラウザの位置情報サービスを許可してご利用ください。
            </li>
          </ul>
        </List>
        <ImgContainer>
          <img
            className="pc"
            src={require("../../../assets/user_guide/step02_pc.png")}
            srcSet={require("../../../assets/user_guide/step02_pc@2x.png")}
            width="948"
            height="485"
            alt="Step02"
          />
          <img
            className="sp"
            src={require("../../../assets/user_guide/step02_sp.png")}
            srcSet={require("../../../assets/user_guide/step02_sp@2x.png")}
            width="343"
            height="485"
            alt="Step02"
          />
        </ImgContainer>
      </StepContainer>

      <StepContainer>
        <StepTitle>
          <StepNum>3</StepNum>商品を選択
        </StepTitle>
        <StepCaption>
          ご利用店舗が決まりましたら、店舗のテイクアウトメニューをご覧いただき、ご希望の商品をカートへ入れてください。
          オプションでごはん量を変更することもできます。
        </StepCaption>
        <List>
          <ul>
            <li>
              ご指定のお受け取り時間により、選べるメニューが変更になります。
            </li>
            <li>
              時間指定の日替わりランチなどは、お受け取り時間内でのご注文のみとなります。
            </li>
          </ul>
        </List>
        <ImgContainer>
          <img
            className="pc"
            src={require("../../../assets/user_guide/step03_1_pc.png")}
            srcSet={require("../../../assets/user_guide/step03_1_pc@2x.png")}
            width="948"
            height="485"
            alt="Step03"
          />
          <img
            className="sp"
            src={require("../../../assets/user_guide/step03_1_sp.png")}
            srcSet={require("../../../assets/user_guide/step03_1_sp@2x.png")}
            width="343"
            height="485"
            alt="Step03"
          />
        </ImgContainer>
        <ImgContainer>
          <img
            className="pc"
            src={require("../../../assets/user_guide/step03_2_pc.png")}
            srcSet={require("../../../assets/user_guide/step03_2_pc@2x.png")}
            width="948"
            height="375"
            alt="Step03"
          />
          <img
            className="sp"
            src={require("../../../assets/user_guide/step03_2_sp.png")}
            srcSet={require("../../../assets/user_guide/step03_2_sp@2x.png")}
            width="343"
            height="250"
            alt="Step03"
          />
        </ImgContainer>
      </StepContainer>

      <StepContainer>
        <StepTitle>
          <StepNum>4</StepNum>商品をカートに入れたらご注文へ
        </StepTitle>
        <StepCaption>
          商品が決まりましたら、画面下部の「カートを確認」ボタンを押し、カート内容をご確認いただき、ご注文手続きにお進みください。
        </StepCaption>
        <ImgContainer>
          <img
            className="pc"
            src={require("../../../assets/user_guide/step04_1_pc.png")}
            srcSet={require("../../../assets/user_guide/step04_1_pc@2x.png")}
            width="948"
            height="375"
            alt="Step04"
          />
          <img
            className="sp"
            src={require("../../../assets/user_guide/step04_1_sp.png")}
            srcSet={require("../../../assets/user_guide/step04_1_sp@2x.png")}
            width="343"
            height="250"
            alt="Step04"
          />
        </ImgContainer>
        <ImgContainer>
          <img
            className="pc"
            src={require("../../../assets/user_guide/step04_2_pc.png")}
            srcSet={require("../../../assets/user_guide/step04_2_pc@2x.png")}
            width="948"
            height="485"
            alt="Step04"
          />
          <img
            className="sp"
            src={require("../../../assets/user_guide/step04_2_sp.png")}
            srcSet={require("../../../assets/user_guide/step04_2_sp@2x.png")}
            width="343"
            height="600"
            alt="Step04"
          />
        </ImgContainer>
      </StepContainer>

      <StepContainer>
        <StepTitle>
          <StepNum>5</StepNum>お受け取り日時にご指定の店舗へ
        </StepTitle>
        <StepCaption>
          ご注文完了画面にて、お受け取りの時間を記載しております。お受け取り日時にご指定の店舗に来店いただき、「お名前」をスタッフにお伝えください。代金をお支払いいただき、商品をお受け取りください。
        </StepCaption>
        <ImgContainer>
          <img
            className="pc"
            src={require("../../../assets/user_guide/step05_1_pc.png")}
            srcSet={require("../../../assets/user_guide/step05_1_pc@2x.png")}
            width="948"
            height="375"
            alt="Step05"
          />
          <img
            className="sp"
            src={require("../../../assets/user_guide/step05_1_sp.png")}
            srcSet={require("../../../assets/user_guide/step05_1_sp@2x.png")}
            width="343"
            height="440"
            alt="Step05"
          />
        </ImgContainer>
      </StepContainer>
      <ButtonWrapper>
        <Button
          text={"テイクアウトをスタート"}
          btnStyle={"primary"}
          onClick={navigateToTopPage}
          rounded="md"
        ></Button>
      </ButtonWrapper>

      {/* Language Display */}
      <TitleWrapper3>表示言語の変更</TitleWrapper3>
      <StepContainer>
        <StepTitle>
          <StepNum>1</StepNum>言語メニューの表示
        </StepTitle>
        <StepCaption>
          右上のメニューから「言語設定」ボタンを押して、言語メニューを表示します。
        </StepCaption>
        <ImgContainer>
          <img
            className="pc"
            src={require("../../../assets/user_guide/lang01_1_pc.png")}
            srcSet={require("../../../assets/user_guide/lang01_1_pc@2x.png")}
            width="948"
            height="438"
            alt="Step04"
          />
          <img
            className="sp"
            src={require("../../../assets/user_guide/lang01_1_sp.png")}
            srcSet={require("../../../assets/user_guide/lang01_1_sp@2x.png")}
            width="343"
            height="440"
            alt="Step04"
          />
        </ImgContainer>
      </StepContainer>

      <StepContainer>
        <StepTitle>
          <StepNum>2</StepNum>言語の選択
        </StepTitle>
        <StepCaption>
          言語メニューから、切り替えたい言語を選択します
        </StepCaption>
        <ImgContainer>
          <img
            className="pc"
            src={require("../../../assets/user_guide/lang02_1_pc.png")}
            srcSet={require("../../../assets/user_guide/lang02_1_pc@2x.png")}
            width="948"
            height="615"
            alt="Step04"
          />
          <img
            className="sp"
            src={require("../../../assets/user_guide/lang02_1_sp.png")}
            srcSet={require("../../../assets/user_guide/lang02_1_sp@2x.png")}
            width="343"
            height="440"
            alt="Step04"
          />
        </ImgContainer>
      </StepContainer>

      <StepContainer>
        <StepTitle>
          <StepNum>3</StepNum>注意書きの表示
        </StepTitle>
        <StepCaption>
          表示したい言語を選択すると、自動でページが翻訳され、選択した言語で注意書きが表示されます。
          <br />
          読み終わりましたら、閉じるボタンを押してポップアップを閉じて、ご注文に進んでください。
        </StepCaption>
        <ImgContainer>
          <img
            className="pc"
            src={require("../../../assets/user_guide/lang03_1_pc.png")}
            srcSet={require("../../../assets/user_guide/lang03_1_pc@2x.png")}
            width="948"
            height="468"
            alt="Step04"
          />
          <img
            className="sp"
            src={require("../../../assets/user_guide/lang03_1_sp.png")}
            srcSet={require("../../../assets/user_guide/lang03_1_sp@2x.png")}
            width="343"
            height="440"
            alt="Step04"
          />
        </ImgContainer>
      </StepContainer>
      <ButtonWrapper>
        <Button
          text={"テイクアウトをスタート"}
          btnStyle={"primary"}
          onClick={navigateToTopPage}
          rounded="md"
        ></Button>
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  margin: 0 auto 80px;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.p`
  font-size: 24px;
  font-weight: 600;
  padding: 43px 0 10px 0;
  display: flex;
  justify-content: center;
  line-height: 1;
  font-family: "Hiragino Sans";
`;

const CaptionContainer = styled.div`
  margin: 30px 0 0 0;
`;
const Caption = styled.p`
  font-weight: 200;
  text-align: left;
  font-size: 14px;
  margin: 0 28px 50px;
  font-family: "Hiragino Sans";
  line-height: 1.7em;
`;

const Guide_img01 = styled.div`
  padding: 23px 0 29px;
  margin: 0 15px 50px;
  background-color: #efefef;
  display: flex;
  justify-content: center;
`;

const TitleWrapper2 = styled.div`
  color: ${BASIC_DARK_GRAY}
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  padding: 12px 0 12px 0;
  margin: 0 15px 30px 15px;
  font-family: "Hiragino Sans";
  border: 1px solid ${BASIC_DARK_GRAY};
`;

const TitleWrapper3 = styled.div`
color: ${BASIC_DARK_GRAY}
font-size: 16px;
font-weight: 600;
text-align: center;
padding: 12px 0 12px 0;
margin: 60px 15px 30px;
border: 1px solid ${BASIC_DARK_GRAY};
`;

const StepContainer = styled.div`
  margin: 0 16px 50px 16px;
  text-align: left;
`;

const StepTitle = styled.p`
  font-size: 20px;
  line-height: 1;
  font-weight: 600;
  margin: 0 0 28px 0;
  font-family: "Hiragino Sans";
`;

const StepNum = styled.span`
  color: ${BASIC_WHITE};
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  padding: 6px 8px 5px;
  border-radius: 4px;
  margin-right: 7px;
  background-color: ${BASIC_YELLOW};
  font-family: "Hiragino Sans";
`;

const StepCaption = styled.p`
  font-weight: 200;
  text-align: left;
  font-size: 14px;
  margin: 0 0 30px;
  font-family: "Hiragino Sans";
  line-height: 1.6em;
`;

const List = styled.div`
  margin-bottom: 36px;
  ul {
    margin: 0;
    padding: 0;

    li {
      font-family: "Hiragino Sans";
      font-size: 13px;
      font-weight: 200;
      line-height: 1.3em;
      margin: 0 0 0.5em;
      padding: 0;
      list-style: none;

      &:before {
        content: "※";
        margin-right: 0.5em;
      }
    }
  }
`;

const SubStepContainer = styled.div`
  background-color: #efefef;
  overflow: hidden;
  margin-bottom: 50px;
`;

const SubTitle = styled.p`
  text-align: center;
  color: ${BASIC_WHITE};
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 20px;
  padding: 12px 0;
  background-color: ${BASIC_GRAY};
  font-family: "Hiragino Sans";
  line-height: 1;
`;

const StepList = styled.ul`
  margin: 0 20px 20px;
  line-height: 0.5em;
  padding: 0;
`;

const StepItem = styled.li`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
  list-style: none;
  display: flex;

  .pre_num {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: ${BASIC_WHITE};
    background-color: ${BASIC_GRAY};
    font-family: "Hiragino Sans";
    font-size: 12px;
    font-weight: 600;
    padding: 6px 0;
    margin-right: 16px;
    width: 80px;
    height: 15px;
    border-radius: 100px;
    text-transform: uppercase;
    white-space: nowrap;
  }
`;

const StepText = styled.p`
  font-size: 14px;
  line-height: 1.8em;
  margin: 0;
  padding: 0;
  font-family: "Hiragino Sans";
`;

const ImgContainer = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  .pc {
    @media screen and (max-width: 780px) {
      display: none;
    }
  }

  .sp {
    display: none;

    @media screen and (max-width: 780px) {
      display: block;
    }
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  button {
    font-weight: 600;
    line-height: 1;
    font-family: "Hiragino Sans";
    height: auto;
  }
`;
